import React, { useEffect } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Button, Row, Col } from 'reactstrap'
import CustomDatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import Input from '../../common/InputGroup'
import { getUsersForCustomSelect } from '../Users/redux/userActions'
import { getDivisionsForCustomSelect } from '../Divisions/redux/DivisionActions'
import { sendPayment, setPaymentData, clearPaymentData } from './Redux/referralReportActions'
import CustomSelect from '../../common/CustomReactSelectComponent'
import { closeModal } from '../../common/GlobalModal/redux/GlobalModalActions'

const PaymentModal = ({
  divisionsForSelect,
  getDivisionsForCustomSelect,
  usersForSelect,
  divisionFrom,
  userDivisionId,
  setPaymentData,
  getUsersForCustomSelect,
  paymentData,
  sendPayment,
  contactIdTask,
  clearPaymentData,
  closeModal,
}) => {
  useEffect(() => {
    return () => {
      clearPaymentData()
    }
  }, [])

  useEffect(() => {
    getUsersForCustomSelect(divisionFrom)
    getDivisionsForCustomSelect()
    setPaymentData({ name: 'id', value: contactIdTask })
  }, [contactIdTask, divisionFrom])

  const onSavePayment = () => {
    closeModal('payment_referral')
    sendPayment()
  }

  return (
    <>
      <div className='payment-modal'>
        <Row>
          <Col>
            <CustomDatePicker
              selected={paymentData.paymentDate ? new Date(paymentData.paymentDate) : ''}
              onChange={(date) =>
                setPaymentData({ name: 'paymentDate', value: moment(new Date(date)).format('MM/DD/YYYY') })
              }
              dateFormat='MM/dd/yyyy'
              label='Payment Date'
              showTimeSelect={false}
              showTimeInput={false}
              isClearable
              placeholder='mm/dd/yyyy'
              customClass='customDataPickerForReferral'
            />
          </Col>
          <Col>
            <Input
              label='Payment Amount'
              type='number'
              onChange={(e) => setPaymentData({ name: 'paymentAmount', value: e.target.value })}
            />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <CustomSelect
              isMulti={false}
              label='Payor'
              placeholder='Payor'
              onChange={(e) => setPaymentData({ name: 'payor', value: e.id })}
              defaultValue={userDivisionId}
              disabled
              options={divisionsForSelect}
            />
          </Col>
          <Col>
            <CustomSelect
              isMulti={false}
              label='Payee'
              placeholder='Payee'
              onChange={(e) => setPaymentData({ name: 'payee', value: e.value })}
              defaultValue={paymentData.payee}
              options={usersForSelect}
            />
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <Button className='gold-color-button float-right' onClick={onSavePayment} size='sm'>
              Save
            </Button>
          </Col>
        </Row>
      </div>
    </>
  )
}

PaymentModal.propTypes = {
  usersForSelect: PropTypes.oneOfType([PropTypes.bool, PropTypes.array, PropTypes.object]),
  divisionsForSelect: PropTypes.oneOfType([PropTypes.bool, PropTypes.array, PropTypes.object]),
  paymentData: PropTypes.object,
}

PaymentModal.defaultProps = {
  usersForSelect: [],
  divisionsForSelect: [],
  paymentData: {},
}

const mapStateToProps = (state) => {
  return {
    userDivisionId: state.auth.user.division_id,
    usersForSelect: state.users.usersForCustomSelect,
    divisionsForSelect: state.divisions.divisionForSelect,
    paymentData: state.ReferralReport.paymentData,
  }
}
export default connect(mapStateToProps, {
  sendPayment,
  getDivisionsForCustomSelect,
  getUsersForCustomSelect,
  setPaymentData,
  clearPaymentData,
  closeModal,
})(PaymentModal)
